import axios from "axios";
import Cookies from "js-cookie";
import { clearAuth } from "utils/auth";

export const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach the current auth token to every request (read fresh each time so a
// new login is picked up without relying on a full page reload).
http.interceptors.request.use(
  function (config: any) {
    const token = Cookies.get("access_token");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error: any) {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  function (response: any) {
    return response;
  },
  function (err: any) {
    // Network/timeout/CORS failures have no `response` to inspect.
    if (!err.response) {
      if (err.message === "Network Error") alert("Network Error");
      return Promise.reject(err);
    }
    // Expired/invalid session on any request (read or write) — but never on
    // the login page itself, so invalid-credential errors still surface there.
    const isUnauthorized =
      err.response.status === 401 ||
      err.response.data?.statusCode === 401;
    if (isUnauthorized && !window.location.pathname.startsWith("/login")) {
      clearAuth();
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);
